import { storeToRefs } from 'pinia/dist/pinia'
import { createRouter, createWebHistory } from 'vue-router'

import { useEventsBus } from '@haskoning/vue-component-library'
import { authRoutes } from '@haskoning/vue-authentication-middleware'
import { useProjectStore } from '@/stores/project'
import { useCalculationStore } from '@/stores/calculation'
import { useDjangoAuthStore } from '@/stores/authDjango'

import ProjectIndexView from '../views/ProjectIndexView.vue'
import ProjectDetailView from '../views/ProjectDetailView.vue'
import UserManagementView from '../views/UserManagementView.vue'
import SpeckleView from '../views/SpeckleView.vue'
import CalculationDetailView from '../views/CalculationDetailView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import CalculationIndexView from '@/views/CalculationIndexView.vue'
import { speckleCallbackRoute } from '@haskoning/vue-speckle'

const { emit } = useEventsBus()
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/:pathMatch(.*)*',
      component: NotFoundView
    },
    {
      path: '/',
      name: 'home',
      redirect: {
        name: 'auth-login'
      }
    },
    authRoutes,
    {
      path: '/projects',
      name: 'project-index',
      component: ProjectIndexView,
      beforeEnter: (to, from) => {
        emit('authenticateSpeckle')
        const store = useProjectStore()
        store.resetAll()
        return true
      }
    },
    {
      path: '/project/:id',
      name: 'project-detail',
      component: ProjectDetailView,
      redirect: {
        name: 'calculation-index'
      },
      children: [
        {
          path: '/project/:id',
          name: 'calculation-index',
          component: CalculationIndexView
        },
        {
          path: '/project/:id/speckle',
          name: 'speckle',
          component: SpeckleView
        },
        {
          path: '/project/:id/user-management',
          name: 'user-management',
          component: UserManagementView
        }
      ],
      beforeEnter: (to, from) => {
        const store = useCalculationStore()
        store.resetAll()
        return true
      }
    },
    {
      path: '/project/:id/calculation/:calculationId',
      name: 'calculation',
      component: CalculationDetailView,
      beforeEnter: async (to, from) => {
        const authStore = useDjangoAuthStore()
        await authStore?.authenticateShipApi()
        return true
      }
    },
    speckleCallbackRoute,
  ]
})

router.beforeEach(async (to, from) => {
  const authStore = useDjangoAuthStore()
  const { user } = storeToRefs(authStore)
  if (!user?.value?.id) {
    const userResponse = await authStore?.reAuthenticate()

    if (userResponse) {
      authStore.$patch({
        user: userResponse.user
      })
    }
  }
  if (to.name && to.name.startsWith('auth-')) {
    if (user.value) {
      return { name: 'project-index' }
    }
    return true
  }
  // check auth and apply login redirect
  if (!user.value) {
    authStore.loginRedirect = to
    return { name: 'auth-login' }
  }
  return true
})

export default router
